import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import CommentBody from "./CommentBody";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { campaignFetcher, commentsFetcher } from "../../api/requests";
import { useLocation } from "react-router-dom";

const CommentBox = () => {
  const { id } = useParams();
  const [comments, setComments] = useState();
  const [error, setError] = useState(null);
  const location = useLocation();
  const campaignId = new URLSearchParams(location.search).get("campaign");

  useEffect(() => {
    const getComments = async () => {
      try {
        const data = campaignId
          ? await campaignFetcher.getCampaignComments(id)
          : await commentsFetcher.getConfirmedComments(id);
        setComments(data);
      } catch (err) {
        console.error("Error fetching comments:", err);
        setError("خطا در نمایش نظرات");
      }
    };

    getComments();
  }, [id]);

  return (
    <>
      <div
        style={{ textAlign: "right" }}
        className="box single-video-comment-tabs"
      >
        <Tabs defaultActiveKey="vidoe">
          <Tab eventKey="vidoe" title="بخش نظرات">
            {error ? (
              <p>{error}</p>
            ) : (
              <CommentBody comments={comments?.results} id={id} />
            )}
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default CommentBox;
